export enum VEHICLE_TYPE {
  SUV = 1,
  HATCHBACK = 2,
  SEDAN = 3,
  CROSSOVER = 4,
}

export enum ROLE {
  ADMIN = 1,
  SUBADMIN = 2,
}

export enum VENDOR_PROFILE_STEPS {
  PERSONAL = 1,
  BANK = 2,
  POLICIES = 3,
  SHIPPING = 4,
  RETURN = 5,
  BRANDING = 6,
  SUBSCRIPTION = 7,
}

export enum ORDER_STATUS {
  PENDING = 1,
  ACCEPT = 2,
  ONGOING = 3,
  COMPLETED = 4,
  CANCELLED = 5,
}
